export const CALM_HUB_PROTOS = ['http:', 'https:', 'calm:'];
export function assertJsonObject(data, source) {
    if (typeof data !== 'object' || data === null || Array.isArray(data)) {
        const kind = data === null ? 'null' : Array.isArray(data) ? 'array' : typeof data;
        // Fatal: the loader successfully fetched this reference, but the payload is invalid.
        // This must surface to the user rather than fall through to another loader.
        throw new DocumentLoadError({
            name: 'UNKNOWN',
            message: `Expected a JSON object from ${source} but received: ${kind}`,
            recoverable: false
        });
    }
}
export class DocumentLoadError extends Error {
    constructor({ name, message, cause, recoverable = true }) {
        super();
        this.name = name;
        this.message = message;
        this.cause = cause;
        this.recoverable = recoverable;
    }
}
//# sourceMappingURL=document-loader.js.map